import { useQuery } from '@apollo/client/react';
import { css } from '@emotion/react';
import { Avatar, Box, Theme } from '@mui/material';
import { addSize } from '@scorenco/core';

import { GetLivePlayerDocument } from '../../EventPostItem.query.generated';

type EventPostActionItemSubstitutionProps = {
  liveIncomingPlayer: any;
  liveOutgoingPlayer: any;
  home: any;
};

export const EventPostActionItemSubstitution = ({
  liveIncomingPlayer,
  liveOutgoingPlayer,
  home,
}: EventPostActionItemSubstitutionProps) => {
  const getIncomingPlayer = useQuery(GetLivePlayerDocument, {
    variables: {
      livePlayerId: liveIncomingPlayer,
    },
    skip: !liveIncomingPlayer,
  });
  const incoming_player = getIncomingPlayer.data?.lives_live_player_by_pk;

  const getOutgoingPlayer = useQuery(GetLivePlayerDocument, {
    variables: {
      livePlayerId: liveOutgoingPlayer,
    },
    skip: !liveOutgoingPlayer,
  });
  const outgoing_player = getOutgoingPlayer.data?.lives_live_player_by_pk;

  const cs = {
    player1: (theme: Theme) => css`
      text-transform: uppercase;
      font-weight: bold;
      font-family: ${theme.typography.fontFamilyAlt};
      margin: 0;
      line-height: 1.2;
    `,
    player2: (theme: Theme) => css`
      text-transform: uppercase;
      font-weight: bold;
      font-family: ${theme.typography.fontFamilyAlt};
      font-size: 0.8rem;
      margin: 0;
      line-height: 1.2;
      color: ${theme.palette.error.main};
    `,
    player: (theme: Theme) => css`
      display: flex;
      border-radius: 0 0 0.25rem 0.25rem;
      overflow: hidden;
      margin-top: -1rem;
      margin-bottom: 1rem;
      padding: 0.5rem 1rem;
      align-items: center;
      justify-content: center;
      background: ${theme.vars.palette.background.default};
      border: 1px solid ${theme.vars.palette.divider};
    `,
  };

  return (
    <Box
      css={cs.player}
      sx={[
        home
          ? {
              backgroundColor: {
                backgroundColor: 'primary.main',
              },
            }
          : {
              backgroundColor: {
                backgroundColor: 'secondary.main',
              },
            },
      ]}
    >
      {incoming_player && (
        <>
          <Avatar
            src={
              addSize(
                incoming_player.player_picture || incoming_player.player?.photo,
                24,
                24
              ) || ''
            }
            css={css`
              width: 2rem;
              height: 2rem;
            `}
          />
          <div
            css={css`
              flex: 1;
              margin-left: 0.5rem;
            `}
          >
            <p css={cs.player1}>
              {incoming_player.number
                ? incoming_player.number + ' - ' + incoming_player.name
                : incoming_player.name}
            </p>
          </div>
        </>
      )}
      {outgoing_player && (
        <div
          css={css`
            /* flex: 1; */
            margin-right: 0.75rem;
          `}
        >
          <p css={cs.player2}>
            {outgoing_player.number
              ? outgoing_player.number + ' - ' + outgoing_player.name
              : outgoing_player.name}
          </p>
        </div>
      )}
    </Box>
  );
};
